var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowBackUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29288 1.29289C5.68341 0.902369 6.31642 0.902369 6.70694 1.29289C7.09734 1.68343 7.09743 2.31647 6.70694 2.70696L4.41398 4.99992H14.9999C19.4181 4.99997 22.9999 8.58168 22.9999 12.9999C22.9999 17.4181 19.4181 20.9999 14.9999 20.9999H8.99991C8.44765 20.9999 7.99995 20.5522 7.99991 19.9999C7.99991 19.4476 8.44763 18.9999 8.99991 18.9999H14.9999C18.3136 18.9999 20.9999 16.3136 20.9999 12.9999C20.9999 9.68625 18.3136 6.99997 14.9999 6.99992H4.41398L6.70694 9.29289C7.09734 9.68343 7.09743 10.3165 6.70694 10.707C6.31646 11.0974 5.68341 11.0973 5.29288 10.707L1.29288 6.70696C0.902365 6.31644 0.90238 5.68342 1.29288 5.29289L5.29288 1.29289Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowBackUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconArrowBackUp.a96a4bab3a9f1d0c7857603418de5995.svg";